export let buildNumber='2.3.35';export let releaseDetails='REL2021_10_15-20220506 15:38 PM';